"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCurrency = void 0;
const config_1 = require("./config");
function formatCurrency(amount, currency = config_1.config.defaultCurrency) {
    return amount.toLocaleString("en", {
        style: "currency",
        currency: currency,
    });
}
exports.formatCurrency = formatCurrency;
